import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/CreateTeacherPage.css'; 
import { useNavigate, useParams } from 'react-router-dom'; 

function TeacherFormPage({ isSidebarCollapsed }) {
  const [branchList, setBranchList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { teacherId } = useParams();

  const [formData, setFormData] = useState({
    teacher_name: '',
    birth_date: '',
    branch_id: '',
    role_id: '',
    phone_number: '',
    address: '',
    salary: '0',
    work_hour_to: '',
    join_date: '',
  });

  const formatCurrency = (amount) => {
    return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
  };

  const handleSalaryChange = (e) => {
    const value = e.target.value.replace(/\./g, ''); // Hapus titik dari input
    setFormData({ ...formData, salary: value }); // Simpan nilai asli
    e.target.value = formatCurrency(value); // Format dan set nilai input
  };

  useEffect(() => {
    api.get('/utils/getBranchList')
      .then(response => setBranchList(response.data.data.branchList))
      .catch(error => console.error('Error fetching branch list:', error));

    api.get('/utils/getRoleList')
      .then(response => setRoleList(response.data.data.roleList))
      .catch(error => console.error('Error fetching role list:', error));

    if (teacherId) {
      api.get(`/teacher/profile/${teacherId}`)
        .then(response => {
          const data = response.data.data[0]; // Sesuaikan dengan struktur respons API Anda
          setFormData({
            teacher_name: data.teacher_name,
            emergency_phone_number: data.emergency_phone_number,
            emergency_contact_person: data.emergency_contact_person,
            birth_date: data.birth_date,
            branch_id: data.branch_id ? data.branch_id : "",
            role_id: data.User.role_id,
            phone_number: data.phone_number,
            address: data.address,
            salary: data.salary,
            work_hour_to: data.work_hour_to,
            join_date: data.join_date,
          });
        })
        .catch(error => console.error('Error fetching teacher profile:', error));
    }
  }, [teacherId]);

  const validateForm = (formData) => {
    const errors = {};
    if (!formData.teacher_name) errors.teacher_name = 'Teacher name is required';
    if (!formData.emergency_phone_number) errors.emergency_phone_number = 'Emergency phone number is required';
    if (!formData.emergency_contact_person) errors.emergency_contact_person = 'Emergency contact person is required';
    if (!formData.birth_date) errors.birth_date = 'Birth date is required';
    if ((formData.role_id === 1 && formData.role_id === 3) && formData.branch_id === "") {
      errors.branch_id = 'Branch is required';
    }
    
    if (formData.role_id === "") errors.role_id = 'Role is required';
    if (!formData.address) errors.address = 'Address is required';
    if (!formData.phone_number) {
      errors.phone_number = 'Phone number is required';
    } else if (!/^\d+$/.test(formData.phone_number)) {
      errors.phone_number = 'Phone number must contain only numbers';
    }
    if (!formData.salary) {
      errors.salary = 'Salary is required';
    } else if (!/^\d+$/.test(formData.salary)) {
      errors.salary = 'Salary must contain only numbers';
    }

    if (!formData.work_hour_to) {
      errors.work_hour_to = 'Work Hour To is required';
    }
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Validation Errors:', validationErrors);
    } else {
      const confirmation = window.confirm('Are you sure you want to proceed with this action?');
      if (!confirmation) {
        return;
      }

      const requestBody = {
        data: {
          teacherData: formData,
        }
      };

      const apiCall = teacherId ? 
        api.put(`/teacher/teacherUpdate/${teacherId}`, requestBody) : 
        api.post('/teacher/teacherSave', requestBody);

      console.log(requestBody);
      apiCall
        .then(response => {
          const successMessage = response.data.message;
          console.log(successMessage);
          navigate('/success', { state: { message: successMessage } });
        })
        .catch(error => {
          console.error('Error adding/updating teacher:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    }
  };

  return (
    <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="page-title">{teacherId ? 'Edit Teacher' : 'Register New Teacher'}</div>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="section">
            <h3 className="section-header">Teacher Data</h3>
            <label>Teacher Name</label>
            <input 
              type="text" 
              name="teacher_name" 
              value={formData.teacher_name} 
              onChange={e => setFormData({ ...formData, teacher_name: e.target.value })} 
              disabled={!!teacherId} 
            />
            {errors.teacher_name && <div className="error-message">{errors.teacher_name}</div>}

            <label>Birth Date</label>
            <input 
              type="date" 
              name="birth_date" 
              value={formData.birth_date} 
              onChange={e => setFormData({ ...formData, birth_date: e.target.value })} 
            />
            {errors.birth_date && <div className="error-message">{errors.birth_date}</div>}

            <label>Branch</label>
            <select 
              name="branch_id" 
              value={formData.branch_id} 
              onChange={e => setFormData({ ...formData, branch_id: e.target.value })}
            >
              <option key="" value="">Select Branch</option>
              {branchList.map(branch => (
                <option key={branch.branch_id} value={branch.branch_id}>{branch.branch_name}</option>
              ))}
            </select>
            {errors.branch_id && <div className="error-message">{errors.branch_id}</div>}

            <label>Phone Number</label>
            <input 
              type="text" 
              name="phone_number" 
              value={formData.phone_number} 
              onChange={e => setFormData({ ...formData, phone_number: e.target.value })} 
            />
            {errors.phone_number && <div className="error-message">{errors.phone_number}</div>}

            <label>Address</label>
            <textarea 
              name="address" 
              value={formData.address} 
              onChange={e => setFormData({ ...formData, address: e.target.value })}
            ></textarea>
            {errors.address && <div className="error-message">{errors.address}</div>}

            {/* Role dan Join Date tidak ditampilkan saat edit */}
            {!teacherId && (
              <>
                <label>Role</label>
                <select 
                  name="role_id" 
                  value={formData.role_id} 
                  onChange={e => setFormData({ ...formData, role_id: e.target.value })}
                >
                  <option key="" value="">Select Role</option>
                  {roleList.map(role => (
                    <option key={role.role_id} value={role.role_id}>{role.name}</option>
                  ))}
                </select>
                {errors.role_id && <div className="error-message">{errors.role_id}</div>}

                <label>Join Date</label>
                <input 
                  type="date" 
                  name="join_date" 
                  value={formData.join_date} 
                  onChange={e => setFormData({ ...formData, join_date: e.target.value })} 
                />
                {errors.join_date && <div className="error-message">{errors.join_date}</div>}
              </>
            )}

            <label>Salary</label>
            <input 
              type="text" 
              name="salary" 
              value={formatCurrency(formData.salary)} 
              onChange={handleSalaryChange} 
            />
            {errors.salary && <div className="error-message">{errors.salary}</div>}
            <label>Work Hour To</label>
            <input 
              type="text" 
              name="work_hour_to" 
              value={formData.work_hour_to} 
              onChange={e => setFormData({ ...formData, work_hour_to: e.target.value })} 
            />
            {errors.work_hour_to && <div className="error-message">{errors.work_hour_to}</div>}
            
            <label>Emergency Contact Person Name</label>
            <input 
              type="text" 
              name="emergency_contact_person" 
              value={formData.emergency_contact_person} 
              onChange={e => setFormData({ ...formData, emergency_contact_person: e.target.value })} 
            />  
            {errors.emergency_contact_person && <div className="error-message">{errors.emergency_contact_person}</div>}

            <label>Emergency Phone Number</label>
            <input 
              type="text" 
              name="emergency_phone_number" 
              value={formData.emergency_phone_number} 
              onChange={e => setFormData({ ...formData, emergency_phone_number: e.target.value })} 
            />
            {errors.emergency_phone_number && <div className="error-message">{errors.emergency_phone_number}</div>}
          </div>

          

          <div className="button-group-profile">
            <button className="profile-button" type="submit">{teacherId ? 'Update' : 'Submit'}</button>  
            <button className="profile-button" onClick={() => navigate('/teacher-list')}>Back</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TeacherFormPage;
